import type { ImageBlock } from '@atlas/renderer';
import type { TUploadedAttachment } from '@atlas/tool/box/file/types';
import uploadFiles from '@atlas/tool/box/file/uploadFiles';
import insertImageNode from '@atlas/tool/box/slate/insertImageNode';
import notify from '@atlas/tool/box/ui/notify';
import createFilestackImageURI from '@atlas/tool/box/file/createFilestackImageURI';
import type { Editor } from 'slate';
import { ReactEditor } from 'slate-react';

export default function insertImage(editor: Editor) {
    uploadFiles({
        maxFiles: 1,
        accept: ['image/jpeg', 'image/png', 'image/webp', 'image/gif'],
    }).then(
        ([uploadedFile]: undefined[] | TUploadedAttachment[] = []) => {
            ReactEditor.focus(editor);
            if (!uploadedFile) return;

            const src = uploadedFile.name.toLowerCase().endsWith('.gif')
                ? uploadedFile.url
                : // Resize to 1300 because Help Center content with is 650 (the half)
                  // and we double it to provide the best experience for retina displays
                  createFilestackImageURI(uploadedFile, { resize: { width: 1300, fit: 'max' } });

            const node: ImageBlock = {
                type: 'image',
                src,
                alt: uploadedFile.name.replace(/\.[\da-z]+$/i, ''),
                align: 'center',
                children: [{ text: '' }],
            };

            insertImageNode(editor, node);
        },
        () => {
            notify.error({ message: 'Failed to upload the file' });
        },
    );
}

// #region Tests

if (import.meta.vitest) {
    const { describe, it } = import.meta.vitest;
    describe('insertImage', async () => {
        it.todo('🤷🏼');
    });
}

// #endregion
